var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8885 12.4983V23.4413C13.9441 23.8579 13.8052 24.3023 13.4858 24.5939C13.3573 24.7226 13.2047 24.8248 13.0367 24.8944C12.8688 24.9641 12.6887 25 12.5068 25C12.3249 25 12.1448 24.9641 11.9768 24.8944C11.8088 24.8248 11.6562 24.7226 11.5278 24.5939L8.73646 21.8026C8.585 21.6545 8.46984 21.4734 8.39998 21.2735C8.33012 21.0735 8.30745 20.8601 8.33374 20.65V12.4983H8.29208L0.293165 2.24969C0.0676517 1.96019 -0.0341045 1.5932 0.0101313 1.2289C0.0543672 0.864607 0.240999 0.532631 0.529244 0.305514C0.793098 0.111096 1.08472 0 1.39024 0H20.832C21.1376 0 21.4292 0.111096 21.693 0.305514C21.9813 0.532631 22.1679 0.864607 22.2122 1.2289C22.2564 1.5932 22.1546 1.96019 21.9291 2.24969L13.9302 12.4983H13.8885Z",
    fill: "#5981E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.56e8e0bf6f26c8b224c41210f14474f6.svg";
export { ForwardRef as ReactComponent };